import { Toast } from "@heroui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";

import { SessionProvider } from "@/src/contexts/AuthContext";
import { router } from "@/src/router";

/**
 * Mêmes réglages que wargame-app, pour que le comportement du cache soit
 * identique d'un dépôt à l'autre.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Ordre des providers, à respecter si tu en ajoutes un :
 *
 *   QueryClientProvider → SessionProvider → RouterProvider
 *
 * `SessionProvider` doit précéder le routeur : les gardes de route
 * (`src/routes/guards.tsx`) et `useApiClient` lisent tous les deux la session.
 *
 * ⚠️ **`Toast.Provider` n'est pas un provider au sens habituel** : malgré son
 * nom, c'est la *région* dans laquelle les toasts s'affichent, et ses enfants
 * décrivent le contenu d'**un** toast. L'utiliser pour envelopper l'application
 * ne rend rien du tout tant qu'aucun toast n'est en file. Il se monte donc en
 * frère de l'arbre, auto-fermant, une seule fois — et hors du routeur, pour
 * qu'un toast survive à un changement de page.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
        <Toast.Provider placement="bottom end" />
      </SessionProvider>
    </QueryClientProvider>
  );
}
